export default __webpack_public_path__ + "static/media/ADIZ_01_mos_JTAN.99cd5f7f.wav";